import { basicInitialState } from '../../_utils/basicInitialState';
import { TEventsState } from './eventsModel';

export const eventsInitialState: TEventsState = {
  ...basicInitialState,
  event: null,
  events: null,
  isNotFound: false,
  scrollTop: 0
};
